<template>
  <transition name="fade">
    <!-- ====== ТРЕЙ-РЕЖИМ (мини-панель) ====== -->
    <div
      v-if="minimized"
      class="process-tray-panel"
      :style="trayStyle"
      ref="tray"
      @mousedown.stop
    >
      <div class="tray-header" @mousedown="startDragTray">
        <span class="tray-title">Глобальная очередь</span>
        <div class="tray-actions">
          <el-tooltip content="Развернуть" placement="top">
            <el-button size="mini" icon="el-icon-full-screen" @click="restoreFromTray" />
          </el-tooltip>
          <el-tooltip content="Закрыть" placement="top">
            <el-button size="mini" icon="el-icon-close" @click="closeCompletely" />
          </el-tooltip>
        </div>
      </div>

      <div v-if="q" class="gq-cards gq-cards--mini">
        <div class="gq-item gq-item--mini">
          <div class="gq-name gq-name--mini">Яндекс Live</div>
          <div class="gq-value gq-value--mini">{{ q.live }}</div>
        </div>
        <div class="gq-item gq-item--mini">
          <div class="gq-name gq-name--mini">Яндекс XML</div>
          <div class="gq-value gq-value--mini">{{ q.xml }}</div>
        </div>
        <div class="gq-item gq-item--mini">
          <div class="gq-name gq-name--mini">Съём частот</div>
          <div class="gq-value gq-value--mini">{{ q.freq }}</div>
        </div>
        <div class="gq-item gq-item--mini">
          <div class="gq-name gq-name--mini">SaaS очередь</div>
          <div class="gq-progress gq-progress--mini">
            <el-tooltip :content="`В очереди: ${q.saas.queued}`" placement="top">
              <el-progress
                :percentage="q.saas.percent"
                :stroke-width="12"
                :show-text="true"
                :text-inside="true"
                :color="saasColor"
              />
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <!-- ====== ПОЛНОЕ ОКНО ====== -->
    <div
      v-else
      class="process-bar"
      :style="barStyle"
      ref="bar"
      @mousedown.stop
    >
      <div class="header" @mousedown="startDragWindow">
        <span>Фоновые процессы</span>
        <div class="header-actions">
          <el-tooltip content="Свернуть в трей" placement="top">
            <el-button size="mini" icon="el-icon-minus" @click="minimizeToTray" />
          </el-tooltip>
          <el-button size="mini" icon="el-icon-close" @click="closeCompletely" />
        </div>
      </div>

      <div v-if="q" class="global-queue">
        <div class="gq-title">Глобальная очередь</div>
        <div class="gq-cards">
          <div class="gq-item">
            <div class="gq-name">Яндекс Live</div>
            <div class="gq-value">{{ q.live }}</div>
          </div>
          <div class="gq-item">
            <div class="gq-name">Яндекс XML</div>
            <div class="gq-value">{{ q.xml }}</div>
          </div>
          <div class="gq-item">
            <div class="gq-name">Съём частот</div>
            <div class="gq-value">{{ q.freq }}</div>
          </div>
          <div class="gq-item">
            <div class="gq-name">SaaS очередь</div>
            <div class="gq-progress">
              <el-tooltip :content="`В очереди: ${q.saas.queued}`" placement="top">
                <el-progress
                  :percentage="q.saas.percent"
                  :stroke-width="16"
                  :show-text="true"
                  :text-inside="true"
                  :color="saasColor"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!processes.length" class="empty">Активных процессов нет</div>

      <div v-else class="table">
        <div v-for="proc in processes" :key="proc.process_key" class="process-row">
          <div class="date">{{ formatDate(proc.created_at) }}</div>
          <div class="name" :title="proc.name">{{ proc.name }}</div>

          <el-progress class="progress" :percentage="proc.progress" :text-inside="false" :stroke-width="10" />

          <div class="percent">{{ proc.progress }} %</div>

          <i class="el-icon-delete trash" @click="confirmCancel(proc)"></i>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { loadSettings, saveSettings } from '@/admin/js/services/tableSettings';

export default {
  name: 'ProcessBar',
  props: {
    processes: { type: Array, required: true },
    queueOverview: { type: Object, default: null }
  },
  data() {
    return {
      minimized: false,
      openState: 'window',
      winPos: { top: 40, left: null },
      draggingWin: false,
      dragOffsetWin: { x: 0, y: 0 },
      trayPos: { right: 16, bottom: 16, width: 520 },
      draggingTray: false,
      dragOffsetTray: { dx: 0, dy: 0 },

      settingsKey: 'processbar.ui'
    };
  },
  computed: {
    q() {
      const q = this.queueOverview;
      return q && q.saas
        ? q
        : { live: 0, xml: 0, freq: 0, saas: { queued: 0, percent: 0 } };
    },
    saasColor() {
      const p = this.q.saas.percent || 0;
      if (p === 0) return '#909399';
      if (p <= 25) return '#409EFF';
      if (p <= 50) return '#67C23A';
      if (p <= 75) return '#E6A23C';
      return '#F56C6C';
    },
    barStyle() {
      if (this.winPos.left == null) {
        return { top: `${this.winPos.top}px`, left: '50%', transform: 'translateX(-50%)' };
      }
      return { top: `${this.winPos.top}px`, left: `${this.winPos.left}px`, transform: 'none' };
    },
    trayStyle() {
      const w = Math.min(this.trayPos.width || 520, window.innerWidth - 32);
      return {
        right: `${Math.max(this.trayPos.right, 8)}px`,
        bottom: `${Math.max(this.trayPos.bottom, 8)}px`,
        width: `${w}px`
      };
    }
  },
  methods: {
    async persistSettings(extra = {}) {
      const payload = {
        minimized: this.minimized,
        openState: this.openState,
        winPos: this.winPos,
        trayPos: this.trayPos,
        ...extra
      };
      this.$emit('open-state-change', payload.openState);
      try { await saveSettings(this.settingsKey, payload); } catch {}
    },
    async loadUISettings() {
      const defaults = {
        minimized: false,
        openState: 'window',
        winPos: { top: 40, left: null },
        trayPos: { right: 16, bottom: 16, width: 520 }
      };
      let cfg = defaults;
      try {
        const loaded = await loadSettings(this.settingsKey, defaults);
        cfg = { ...defaults, ...(loaded || {}) };
      } catch {}
      this.minimized = !!cfg.minimized;
      this.openState = cfg.openState || (this.minimized ? 'tray' : 'window');
      this.winPos = { ...defaults.winPos, ...(cfg.winPos || {}) };
      this.trayPos = { ...defaults.trayPos, ...(cfg.trayPos || {}) };

      if (this.openState === 'tray') this.minimized = true;
      if (this.openState === 'window') this.minimized = false;
    },

    /* ====== Кнопки ====== */
    minimizeToTray() {
      this.minimized = true;
      this.openState = 'tray';
      this.persistSettings();
    },
    restoreFromTray() {
      this.minimized = false;
      this.openState = 'window';
      this.persistSettings();
    },
    closeCompletely() {
      this.openState = 'closed';
      this.persistSettings();
      this.$emit('processCompletedAll');
    },

    /* ====== Отрисовка дат ====== */
    formatDate(d) {
      return new Date(d).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    /* ====== Управление процессом ====== */
    async confirmCancel(proc) {
      try {
        await this.$confirm(`Удалить процесс «${proc.name}»?`, 'Подтверждение', {
          type: 'warning', confirmButtonText: 'Удалить', cancelButtonText: 'Отмена'
        });
        await axios.delete(`/api/admin/process/by-key/${encodeURIComponent(proc.process_key)}`);
        this.$message.success('Процесс остановлен');
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e?.response?.data?.message || 'Не удалось удалить процесс');
        }
      }
    },

    /* ====== DRAG: ОКНО ====== */
    startDragWindow(e) {
      if (e.target.closest('.header-actions')) return;
      const el = this.$refs.bar;
      if (!el) return;
      this.draggingWin = true;
      const rect = el.getBoundingClientRect();
      this.dragOffsetWin = { x: e.clientX - rect.left, y: e.clientY - rect.top };
      document.addEventListener('mousemove', this.onDragWindow);
      document.addEventListener('mouseup', this.stopDragWindow);
    },
    onDragWindow(e) {
      if (!this.draggingWin) return;
      const el = this.$refs.bar;
      if (!el) return;
      const newLeft = e.clientX - this.dragOffsetWin.x;
      const newTop = e.clientY - this.dragOffsetWin.y;
      const w = el.offsetWidth || 700;
      const h = el.offsetHeight || 300;
      const maxLeft = window.innerWidth - w - 8;
      const maxTop = window.innerHeight - h - 8;
      this.winPos.left = Math.min(Math.max(newLeft, 8), Math.max(maxLeft, 8));
      this.winPos.top = Math.min(Math.max(newTop, 8), Math.max(maxTop, 8));
    },
    stopDragWindow() {
      if (!this.draggingWin) return;
      this.draggingWin = false;
      document.removeEventListener('mousemove', this.onDragWindow);
      document.removeEventListener('mouseup', this.stopDragWindow);
      if (this.winPos.left == null) {
        const el = this.$refs.bar;
        const w = el ? el.offsetWidth : 700;
        this.winPos.left = Math.max((window.innerWidth - w) / 2, 8);
      }
      this.persistSettings();
    },

    /* ====== DRAG: ТРЕЙ ====== */
    startDragTray(e) {
      if (e.target.closest('.tray-actions')) return;
      const panel = this.$refs.tray;
      if (!panel) return;
      this.draggingTray = true;
      this.dragOffsetTray = {
        dx: window.innerWidth - e.clientX - this.trayPos.right,
        dy: window.innerHeight - e.clientY - this.trayPos.bottom
      };
      document.addEventListener('mousemove', this.onDragTray);
      document.addEventListener('mouseup', this.stopDragTray);
    },
    onDragTray(e) {
      if (!this.draggingTray) return;
      const right = Math.max(window.innerWidth - e.clientX - this.dragOffsetTray.dx, 8);
      const bottom = Math.max(window.innerHeight - e.clientY - this.dragOffsetTray.dy, 8);
      const panel = this.$refs.tray;
      const width = (panel ? panel.offsetWidth : this.trayPos.width) || 520;
      const maxRight = Math.max(window.innerWidth - width - 8, 8);
      this.trayPos.right = Math.min(right, maxRight);
      this.trayPos.bottom = bottom;
    },
    stopDragTray() {
      if (!this.draggingTray) return;
      this.draggingTray = false;
      document.removeEventListener('mousemove', this.onDragTray);
      document.removeEventListener('mouseup', this.stopDragTray);
      this.persistSettings();
    },
  },
  async mounted() {
    await this.loadUISettings();
    this.$nextTick(() => {
      const panel = this.$refs.tray;
      if (panel) this.trayPos.width = Math.min(this.trayPos.width, window.innerWidth - 32);
    });
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDragWindow);
    document.removeEventListener('mouseup', this.stopDragWindow);
    document.removeEventListener('mousemove', this.onDragTray);
    document.removeEventListener('mouseup', this.stopDragTray);
  }
};
</script>

<style scoped>
/* ====== ПОЛНОЕ ОКНО ====== */
.process-bar {
  position: fixed;
  background: #fff;
  padding: 16px 20px;
  max-width: 700px;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
  z-index: 9999;
  font-size: 14px;
  color: #333;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
  flex: 0 0 auto;
  cursor: move;
}
.header-actions { display: flex; gap: 6px; }

.table {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
  overflow-y: auto;
  scrollbar-gutter: stable both-edges;
}
.process-row {
  display: grid;
  grid-template-columns: 110px 270px 1fr 29px 36px;
  align-items: center;
  gap: 12px;
}
@media (max-width: 720px) {
  .process-bar { max-width: 92vw; }
  .process-row { grid-template-columns: 100px 1fr 80px 29px 36px; }
}
.empty { padding: 20px 0; text-align: center; color: #888; }
.date { white-space: nowrap; font-size: 13px; color: #888; }
.name { font-weight: 500; color: #409EFF; overflow: hidden; text-overflow: ellipsis; }
.progress { width: 100%; height: 18px; }
.percent { text-align: right; font-variant-numeric: tabular-nums; }
.trash { cursor: pointer; font-size: 20px; color: #999; transition: color 0.2s; }
.trash:hover { color: #666; }

/* ====== ГЛОБАЛЬНАЯ ОЧЕРЕДЬ (полная) ====== */
.global-queue { margin: 10px 0 14px; padding-bottom: 10px; border-bottom: 1px solid #eee; }
.gq-title { font-weight: 500; margin-bottom: 8px; font-size: 16px; }
.gq-cards { display: grid; grid-template-columns: repeat(4, minmax(130px, 1fr)); gap: 10px; }
.gq-item { background: #f8fafc; border: 1px solid #eef2f7; border-radius: 8px; padding: 10px 12px; display: flex; flex-direction: column; gap: 6px; }
.gq-name { font-size: 12px; color: #6b7280; margin-bottom: 6px; }
.gq-value { font-size: 18px; font-weight: 700; }
.gq-saastag .gq-value { display: inline-flex; align-items: center; }
.gq-progress .el-progress { width: 100%; }
@media (max-width: 720px) { .gq-cards { grid-template-columns: repeat(2, 1fr); } }

/* ====== ТРЕЙ-ПАНЕЛЬ (мини) ====== */
.process-tray-panel {
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: 520px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  padding: 10px 12px;
  z-index: 9999;
}
.tray-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 6px;
  border-bottom: 1px solid #eee;
  cursor: move;
}
.tray-title { font-weight: 600; color: #333; }
.tray-actions { display:flex; gap:6px; }
.gq-cards--mini { margin-top: 8px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.gq-item--mini { background: #f8fafc; border: 1px solid #eef2f7; border-radius: 8px; padding: 8px 10px; }
.gq-name--mini { font-size: 11px; color: #6b7280; margin-bottom: 4px; }
.gq-value--mini { font-size: 18px; font-weight: 700; }
.gq-progress--mini .el-progress { width: 100%; }
@media (max-width: 640px) {
  .process-tray-panel { width: 100%; right: 8px; left: 8px; }
  .gq-cards--mini { grid-template-columns: 1fr 1fr; }
}
</style>
